module.exports = __webpack_public_path__ + "assets/img/file.e3237bbd.svg";